import axios from '../plugins/axios'

const API_URL = process.env.VUE_APP_API_URL + '/motorbikes/'
class MotorbikesAPI {
  list() {
    return axios
      .get(API_URL)
      .then(response => {
        return response.data
      })
  }
  show(id) {
    return axios
      .get(API_URL + id)
      .then(response => {
        return response.data
      })
  }
  edit(id, motorbike) {
    return axios
      .put(API_URL + id, {
        acquisitionDate: motorbike.acquisitionDate,
        acquisitionKm: motorbike.acquisitionKm,
        acquisitionProvider: motorbike.acquisitionProvider,
        acquisitionPrice: motorbike.acquisitionPrice,
        brand: motorbike.brand,
        cc: motorbike.cc,
        color: motorbike.color,
        licenseplate: motorbike.licenseplate,
        model: motorbike.model,
        firstRegistrationDate: motorbike.firstRegistrationDate
      })
      .then(response => {
        return response.data
      })
  }
  create(motorbike) {
    return axios
      .post(API_URL, {
        acquisitionDate: motorbike.acquisitionDate,
        acquisitionKm: motorbike.acquisitionKm,
        acquisitionProvider: motorbike.acquisitionProvider,
        acquisitionPrice: motorbike.acquisitionPrice,
        brand: motorbike.brand,
        cc: motorbike.cc,
        color: motorbike.color,
        licenseplate: motorbike.licenseplate,
        model: motorbike.model,
        firstRegistrationDate: motorbike.firstRegistrationDate
      })
      .then(response => {
        return response.data
      })
  }
  delete(id) {
    return axios
      .delete(API_URL + id)
      .then(response => {
        return response.data
      })
  }
}
export default new MotorbikesAPI()